import React, {useState, useEffect} from "react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import careerImage from "../images/career-image.png";
import recordsImage from "../images/records-image_2.png";
import housingImage from "../images/housing-image_2.png";
import disabilityImage from "../images/disability-image_2.png";
import memorialImage from "../images/memorial-image_2.png";
import healthImage from "../images/health-image_2.png";
import socialImage from "../images/social-image_2.png";
import financialImage from "../images/financial-image_2.png";
import educationImage from "../images/education-image_2.png";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { WelcomePopUp } from "../WelcomePopUp";

const descriptionDict = {
    Career: "VetNav is committed to serving veterans who are looking for meaningful employment and opportunities to advance economically. VetNav ensures that veterans receive access to the resources they need to start a new career. ",
    Education: "VetNav helps veterans complete their education as a first step towards realizing a purpose-driven life. VetNav provides a list of resources to finance your education, receive tutoring, find a mentorship program, and more. ",
    Health: "VetNav prioritizes the physical and mental health of the veteran community. VetNav connects veterans to the services they need to meet their unique health challenges and help manage chronic illnesses, disabilities, injuries, and mental health challenges. ",
    Housing: "VetNav connects all veterans to the housing services that are right for them. VetNav provides a comprehensive resource guide for veterans at every stage of their housing journey. ",
    Social: "VetNav connects veterans to programs and resources that promote social enrichment, including volunteer opportunities, civic engagement, professional networking, and peer support resources. ",
    Financial: "VetNav supports veterans and their families who are experiencing financial hardships. VetNav also provides information on investing, financial tools, and how to protect investments. ",
    "Disability and Pension": "VetNav helps veterans looking to secure disability compensation from the VA. VetNav connects veterans with disabilities to employment opportunities, job training programs, resources to modify their homes, and more. ",
    Memorial: "VetNav ensures that veterans receive dignified funerals and burial services. ",
    Records: "VetNav assists veterans looking for records information and discharge upgrade assistance. VetNav also connects veterans to free legal assistance. ",
}

const descriptionText = 'Click on the individual resources to learn more about them by accessing their sites directly. Additionally, if you’d like to connect with a representative from the DVS to discuss your options, click on “Additional Help”.'

const imageDict = {
    Career: careerImage,
    Education: educationImage,
    Health: healthImage,
    Housing: housingImage,
    Social: socialImage,
    Financial: financialImage,
    "Disability & Pension": disabilityImage,
    Memorial: memorialImage,
    Records: recordsImage,
}


export const ResourcesPage = (props) => {
    const {
        resources,
        selections,
        configurationData,
        setSelections,
        diversityDict,
        setDiversityDict,
        isWelcome,
        setIsWelcome,
    } = props
    const finalSelection = selections[selections?.length - 1]
    const finalSelectionRow = configurationData.data.find(configRow => (
        configRow[5] === finalSelection
    ))
    // const finalSelectionResourceString = finalSelectionRow[6]
    // const finalSelectionResources = finalSelectionResourceString.length > 0 ?
    //     finalSelectionResourceString.split(";") :
    //     null
    // let resourceObjs = finalSelectionResources?.map(resourceId => {
    //     const resourceObj = resources[resourceId]
    //     return(
    //         <div className="resource-link">
                // <a href={resourceObj.url} target="_blank">
                //     {`- ${resourceObj.linkName}`}
                // </a>
    //         </div>
    //     )
    // })
    const formattedResources = finalSelectionRow[9].split("&&")
    const finalSelectionCategories = finalSelectionRow[8].split(";")
    console.log(finalSelectionCategories)

    useEffect(() => {
        if (finalSelectionCategories.length === 1) {
            setExpandedCategory([finalSelectionCategories[0]])
        }
    }, [selections])
    const [expandedCategory, setExpandedCategory] = useState([])
    // if (resourceObjs?.length === 1) {
    //     resourceObjs = [
    //         <div className="resource-header">
    //             National Resources
    //         </div>,
    //         ...resourceObjs
    //     ]
    // } else if (resourceObjs?.length > 0) {
    //     resourceObjs = [
    //         <div className="resource-header">
    //             National Resources
    //         </div>,
    //         <div className="resource-header">
    //             Regional Resources
    //         </div>,
    //         ...resourceObjs]
    // }
    const handleSelectCategory = (category, isExpanded) => {
        let newExpandedList = expandedCategory
        if (isExpanded) {
            newExpandedList = expandedCategory.filter(expandedCat => (
                expandedCat !== category
            ))
        } else {
            newExpandedList.unshift(category)
        }
        setExpandedCategory([...newExpandedList])
    }
    const formattedResourceObjs = finalSelectionCategories.map((category, i) => {
        const finalSelectionResourceString = formattedResources[i]
        const finalSelectionResources = finalSelectionResourceString?.length > 0 ?
            finalSelectionResourceString.split(";") :
            null
        let resourceObjs = finalSelectionResources?.map(resourceId => {
            const resourceObj = resources[resourceId]
            console.log(resourceId)
            console.log(resourceObj)
            console.log(resourceObj?.linkName)
            if (resourceId && resourceObj) {
                return(
                    <div className="resource-row">
                        <div className="resource-link">
                            <a href={resourceObj?.url} target="_blank">
                                {`${resourceObj?.linkName}`}
                            </a>
                        </div>
                        <div>
                            {`${resourceObj?.description}`}
                        </div>
                    </div>
                )
            }
        })
        if (category === "Are you looking for resources tailored to your experience:") {
            const filteredDiversity = Object.values(diversityDict).filter(bool => (
                bool
            ))
            if (filteredDiversity.length < 2) {
                return null
            }
        }
        const isExpanded = expandedCategory.find(expandedCat => (
            expandedCat === category
        ))
        return (
            <div className={`resource-box-container ${isExpanded ? '': 'hidden'}`}>
                <div
                    className="resource-header"
                    onClick={() => handleSelectCategory(category, isExpanded)}
                >
                    <div>
                        {category}
                    </div>
                    <div className="expand-icon">
                        {isExpanded ? <RemoveIcon style={{height: '3vh', width: '3vh'}}/> : <AddIcon style={{height: '3vh', width: '3vh'}}/>}
                    </div>
                </div>
                    {isExpanded && (
                        <div className={`resource-list`}>
                            {resourceObjs}
                        </div> 
                    )}
            </div>
        )
    })
    return (
        <>
            <div className="resource-page-content">
                <div className="header-text">
                    {selections[selections.length - 1]}
                </div>
                <div className="question-banner-description">
                    {descriptionText}
                </div>
                <div className="resource-content">
                    <div className="resource-left-panel">
                        <div className="resource-boxes">
                            {formattedResourceObjs}
                        </div>
                        <div className="resource-buttons">
                            <div className={`next-button blue`} onClick={()=>setIsWelcome('feedback')}>
                                Feedback
                            </div>
                            <div className="resource-buttons right-container">
                                <a className={`next-button blue right`} href={"https://www.canva.com/design/DAGZAPzAq_4/jSs6bp9LmoFb5aiyHYHuww/view?utlId=had9940e248&utm_campaign=designshare&utm_medium=link2&utm_content=DAGZAPzAq_4&utm_source=uniquelinks#1"} target="_blank">
                                    Customized Services
                                </a>
                                <a className={`next-button blue right`} href={"https://ask.va.gov/ask-a-question/"} target="_blank">
                                    Connect to VA
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}